import React from 'react';
import { Chip } from '@mui/material';
import { GridColDef, GridPaginationModel } from '@mui/x-data-grid';
import { FDataGrid } from '../grid';
import { IForecastQualityIssue } from './bieforecasting.models';

type Props = {
  rows: IForecastQualityIssue[];
  rowCount: number;
  loading?: boolean;
  paginationModel: GridPaginationModel;
  onPaginationModelChange: (model: GridPaginationModel) => void;
  onRefresh?: () => void;
};

class ForecastQualityIssueGrid extends React.PureComponent<Props> {
  private getRowId = (row: IForecastQualityIssue) => row.id;

  private columns: GridColDef[] = [
    {
      field: 'severity',
      headerName: 'Severity',
      width: 120,
      renderCell: (p) => (
        <Chip
          size="small"
          label={String(p.value || 'INFO')}
          color={p.value === 'BLOCKING' ? 'error' : p.value === 'WARNING' ? 'warning' : 'info'}
        />
      ),
    },
    { field: 'issuecode', headerName: 'Code', width: 190 },
    { field: 'message', headerName: 'Issue', flex: 1, minWidth: 320 },
    { field: 'variablecode', headerName: 'Variable', width: 150 },
    { field: 'productcode', headerName: 'Product', width: 140 },
    { field: 'locationcode', headerName: 'Location', width: 140 },
    { field: 'periodcode', headerName: 'Period', width: 120 },
    { field: 'actualvalue', headerName: 'Actual', width: 130, type: 'number' },
    { field: 'expectedvalue', headerName: 'Expected', width: 130, type: 'number' },
    { field: 'status', headerName: 'Status', width: 120 },
    { field: 'resolution', headerName: 'Resolution', flex: 1, minWidth: 240 },
  ];

  render() {
    return (
      <FDataGrid
        title="Forecast Quality Issues"
        subtitle="Persisted exceptions and blocking findings from the latest quality validation run."
        rows={this.props.rows || []}
        columns={this.columns}
        loading={this.props.loading}
        getRowId={this.getRowId}
        height={460}
        showQuickFilter
        paginationMode="server"
        rowCount={this.props.rowCount}
        paginationModel={this.props.paginationModel}
        onPaginationModelChange={this.props.onPaginationModelChange}
        pageSizeOptions={[10, 25, 50, 100]}
      />
    );
  }
}

export default ForecastQualityIssueGrid;
